import moment from 'moment';

import './date.style.sass';
import template from './date.tpl.pug';

class DateController {
    $onInit() {
        this.$ctrl.$formatters.push(this.formatter.bind(this));
        this.$ctrl.$parsers.push(this.parser.bind(this));
        this.$ctrl.$render = this.render.bind(this);
    }

    formatter(value) {
        return moment(value).format('MMMM D YYYY');
    }

    parser(value) {
        return moment(value, 'MMMM D YYYY').valueOf();
    }

    render() {
        this.value = this.$ctrl.$viewValue;
    }

    click() {
        if (!this.disabled) {
            return this.onClick();
        }
    }
}

export default {
    selector: 'dbADate',
    template: template(),
    controller: DateController,
    require: {
        $ctrl: 'ngModel'
    },
    bindings: {
        disabled: '<',
        onClick: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/date/date.cmpt.js